import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import GenericTable from '../../../../../components_v2/common/GenericTable/GenericTable';
import s from './PointsTable.scss';

const PointsTableList = props => {
  const {
    tabData = [],
    activeTab,
    className = '',
    isWapView = false,
    hideFlags,
    isFifaPage,
    headerHeading = [],
    isIplPointsTable,
    pointsTableType,
  } = props;
  const [accordianOpen, setAccordianOpen] = React.useState(-1);
  const toggleAccordian = index => {
    if (index === accordianOpen) {
      setAccordianOpen('');
    } else {
      setAccordianOpen(index);
    }
  };
  const teamMatchesColums = [
    { key: 'opponent', label: 'Opponent' },
    { key: 'date', label: 'Date' },
    { key: 'result', label: 'Result' },
  ];
  return (
    <ul
      className={`${s.list} ${s.fifaTable} ${className} ${
        (tabData.name && activeTab === tabData.name) || !activeTab
          ? s.listActive
          : ''
      }`}
    >
      {(() => {
        if (isFifaPage) {
          return (
            <li className={s.head}>
              {headerHeading.items &&
                Array.isArray(headerHeading.items) &&
                headerHeading.items.length &&
                headerHeading.items.map((item, i) => (
                  <>
                    {i === 0 && <span className={s.count}>{item.name}</span>}
                    {i === 1 && (
                      <span className={s.countryname}>{item.name}</span>
                    )}
                    {i > 1 && <span className={s.matches}>{item.name}</span>}
                  </>
                ))}
            </li>
          );
        }

        if (pointsTableType === 'points_table_WTC') {
          return (
            <li className={`${s.head} ${s.sticky_head}`}>
              <span className={s.count}>POS</span>
              <span className={s.countryname}>Team</span>
              <span className={s.matches}>Played</span>
              <span className={s.matches}>Won</span>
              <span className={s.matches}>Lost</span>
              <span className={s.matches}>Draw</span>
              <span className={s.matches}>DED</span>
              <span className={s.matches}>Points</span>
              <span className={s.matches}>PCT</span>
              {/* <span className={s.arrowWrap} /> */}
            </li>
          );
        }

        return (
          <li className={`${s.head}`}>
            <span className={s.count}>#</span>
            <span className={s.countryname}>Teams</span>
            <span className={s.matches}>Played</span>
            <span className={s.matches}>won</span>
            <span className={s.matches}>lost</span>
            {!isWapView && activeTab && <span className={s.matches}>N/r</span>}
            <span className={s.matches}>net rr</span>
            <span className={s.matches}>points</span>
            <span className={s.arrowWrap} />
          </li>
        );
      })()}
      {isFifaPage &&
        !props?.ifFifaHomePageWidget &&
        tabData.team &&
        Array.isArray(tabData.team) &&
        tabData.team.length &&
        tabData.team.map((team, i) => (
          <li className={`${s.selected}`} key={team.id}>
            <span className={s.count}>{i + 1}</span>
            <span className={s.countryname}>
              {!hideFlags && (
                <span
                  className={`${s.fifaTeamFlag} ${
                    team.short_name && team.short_name.includes('-U19')
                      ? s[team.short_name.replace('-U19', '')]
                      : s[team.short_name]
                  }`}
                />
              )}{' '}
              {team.link && (
                <Link to={team.link}>
                  {isWapView ? team.short_name : team.name}
                </Link>
              )}
              {!team.link && <>{isWapView ? team.short_name : team.name}</>}
            </span>
            <span className={s.matches}>{team.p}</span>
            <span className={s.matches}>{team.w}</span>
            {team.d && <span className={s.matches}>{team.d}</span>}
            {team.l && <span className={s.matches}>{team.l}</span>}
            {team.nrr && <span className={s.matches}>{team.nrr}</span>}
            <span className={s.matches}>{team.pts}</span>
          </li>
        ))}
      {isFifaPage &&
        props?.ifFifaHomePageWidget &&
        tabData?.team &&
        Array.isArray(tabData?.team) &&
        tabData?.team.length &&
        tabData?.team.map((team, i) => (
          <li className={s.selected} key={team?.id}>
            <span className={s.count}>{i + 1}</span>
            <span className={s.countryname}>{team?.short_name}</span>
            <span className={s.matches}>{team?.p}</span>
            {props?.currentTab !== 'Results' && (
              <span className={s.matches}>{team?.w}</span>
            )}
            {props?.currentTab === 'Points Table' && (
              <span className={s.matches}>{team?.d}</span>
            )}
            {props?.currentTab === 'Points Table' && (
              <span className={s.matches}>{team?.l}</span>
            )}
            {props?.currentTab === 'Points Table' && (
              <span className={s.matches}>{team?.nrr}</span>
            )}
            {(props?.currentTab === 'Points Table' ||
              props?.currentTab === 'Results') && (
              <span className={s.matches}>{team?.pts}</span>
            )}
          </li>
        ))}
      {!isFifaPage &&
        tabData.team &&
        Array.isArray(tabData.team) &&
        tabData.team.length &&
        tabData.team.map((team, index) => (
          <>
            {pointsTableType !== 'points_table_WTC' && (
              <li className={s.selected} key={team.id}>
                <span className={s.count}>{team.pos}</span>
                <span className={s.countryname}>
                  {!hideFlags && (
                    <span
                      className={`${s.teamFlag} ${
                        team.short_name && team.short_name.includes('-U19')
                          ? s[team.short_name.replace('-U19', '')]
                          : s[team.short_name]
                      }`}
                    />
                  )}{' '}
                  {team.link && (
                    <Link to={team.link}>
                      {isWapView ? team.short_name : team.name}
                    </Link>
                  )}
                  {!team.link && <>{isWapView ? team.short_name : team.name}</>}
                </span>
                <span className={s.matches}>{team.p}</span>
                <span className={s.matches}>{team.w}</span>
                <span className={s.matches}>{team.l}</span>
                {!isWapView &&
                  activeTab && <span className={s.matches}>{team.nr}</span>}
                <span className={s.matches}>{team.nrr}</span>
                <span className={s.matches}>{team.pts}</span>
                {isIplPointsTable && (
                  <span
                    className={s.arrowWrap}
                    onClick={() => toggleAccordian(index)}
                  >
                    <i
                      className={`${s.arrowDown} ${index === accordianOpen &&
                        s.arrowUp}`}
                    />
                  </span>
                )}
              </li>
            )}
            {pointsTableType === 'points_table_WTC' && (
              <li className={`${s.selected} ${s.sticky_head}`} key={team.id}>
                {isIplPointsTable &&
                  team?.matches &&
                  Array.isArray(team?.matches) &&
                  team?.matches.length > 0 && (
                    <span
                      className={s.arrowWrap}
                      onClick={() => toggleAccordian(index)}
                    >
                      <i
                        className={`${s.arrowDown} ${index === accordianOpen &&
                          s.arrowUp}`}
                      />
                    </span>
                  )}
                <span className={s.count}>
                  {team.is_qualified && team.is_qualified === 'true' ? 'Q' : ''}{' '}
                  {team.position}
                </span>
                <span className={s.countryname}>
                  {!hideFlags && (
                    <span
                      className={`${s.teamFlag} ${
                        team.team_short_name &&
                        team.team_short_name.includes('-U19')
                          ? s[team.team_short_name.replace('-U19', '')]
                          : s[team.team_short_name]
                      }`}
                    />
                  )}{' '}
                  {team.link && (
                    <Link to={team.link}>
                      {isWapView ? team.team_short_name : team.team_name}
                    </Link>
                  )}
                  {!team.link && (
                    <>{isWapView ? team.team_short_name : team.team_name}</>
                  )}
                </span>
                <span className={s.matches}>{team.matches_played}</span>
                <span className={s.matches}>{team.matches_won}</span>
                <span className={s.matches}>{team.matches_lost}</span>
                <span className={s.matches}>{team.matches_tied}</span>
                <span className={s.matches}>{team.penalty}</span>
                <span className={s.matches}>{team.points}</span>
                <span className={`${s.matches} ${s.pct}`}>
                  {team.points_contested_and_total_points_ratio}
                </span>
              </li>
            )}
            {isIplPointsTable &&
              team?.matches &&
              Array.isArray(team?.matches) &&
              team?.matches.length > 0 &&
              (() => {
                const data = team.matches.map(match => ({
                  opponent:
                    match?.vs_shortname ||
                    (match?.team2_short_name &&
                    team?.team_short_name !== match?.team2_short_name
                      ? match?.team2_short_name
                      : match?.team1_short_name),
                  date: match?.date,
                  result:
                    match?.match_result || match?.result || match?.event_status,
                  matchLink: match?.matchLink,
                }));
                return (
                  <li
                    className={`${s.tableWrapper} ${
                      index === accordianOpen ? s.tableOpen : ''
                    }`}
                  >
                    <GenericTable
                      columns={teamMatchesColums}
                      data={data}
                      isLinked
                      xAxisScrollable={isWapView}
                      isIplPointsTable
                    />
                  </li>
                );
              })()}
          </>
        ))}
    </ul>
  );
};

PointsTableList.propTypes = {
  tabData: PropTypes.arrayOf({}),
  activeTab: PropTypes.string,
  className: PropTypes.string,
  isWapView: PropTypes.bool,
  hideFlags: PropTypes.string,
  isFifaPage: PropTypes.string,
  headerHeading: PropTypes.arrayOf({}),
  ifFifaHomePageWidget: PropTypes.bool,
  currentTab: PropTypes.string,
  isIplPointsTable: PropTypes.bool,
};
PointsTableList.defaultProps = {
  tabData: [],
  activeTab: '',
  hideFlags: '',
  isFifaPage: '',
  className: '',
  isWapView: false,
  headerHeading: [],
  ifFifaHomePageWidget: false,
  currentTab: '',
  isIplPointsTable: false,
};

export default React.memo(PointsTableList);
